import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BorderColor = forwardRef<SVGSVGElement, IconProps>(({ color, size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 -4 18 24"
      fill="none"
      stroke={'currentColor'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.5 2.5h11v9h-11z" />
      <path d="M3.5 2.5h5.6v9H3.5z" />
      <path d="M3.5 2.5h11V7h-11z" />
      <rect
        x=".5"
        y="14.5"
        width="17"
        height="3"
        rx="1.5"
        strokeOpacity={color ? '1.0' : '0.3'}
        stroke={color ?? 'currentColor'}
        fill={color ?? 'none'}
      />
    </svg>
  )
})

export default BorderColor
